import React from "react";
import { SiteHeader } from "../components/SiteHeader";
import { Hero } from "../components/Hero";
import { ConnectionSection } from "../components/ConnectionSection";
import { SolutionSection } from "../components/SolutionSection";
import { ContentsSection } from "../components/ContentsSection";
import { ActivityBookSection } from "../components/ActivityBookSection";
import { EmotionalSection } from "../components/EmotionalSection";
import { BonusSection } from "../components/BonusSection";
import { HowItWorksSection } from "../components/HowItWorksSection";
import { PersonaSection } from "../components/PersonaSection";
import { OfferSection } from "../components/OfferSection";
import { GuaranteeSection } from "../components/GuaranteeSection";
import { FaqSection } from "../components/FaqSection";
import { ClosingSection } from "../components/ClosingSection";
import { SiteFooter } from "../components/SiteFooter";
export function Landing() {
  return <div className="min-h-screen w-full bg-ivory font-sans text-cocoa" data-id="element-257" data-mp="m591z0tgkr16">
      <SiteHeader data-id="element-258" data-mp="2bbo67oxjvyw" />
      <main data-id="element-259" data-mp="27nv19nedbkp">
        <Hero data-id="element-260" data-mp="3tgbj3xd0vcvy" />
        <ConnectionSection data-id="element-261" data-mp="3tftm2yijcumz" />
        <SolutionSection data-id="element-262" data-mp="3tfjwvd5beric" />
        <ContentsSection data-id="element-263" data-mp="3tiftmy5ffa57" />
        <ActivityBookSection data-id="element-264" data-mp="3peggmpjcutgl" />
        <EmotionalSection data-id="element-265" data-mp="3pfrk0o8w1z76" />
        <BonusSection data-id="element-266" data-mp="3pf004aonlpwq" />
        <HowItWorksSection data-id="element-267" data-mp="3pgksbtnhwwrf" />
        <PersonaSection data-id="element-268" data-mp="3kg6ic62c3cqr" />
        <OfferSection data-id="element-269" data-mp="3kgyfhlbkxij5" />
        <GuaranteeSection data-id="element-270" data-mp="3khhqei2tb6no" />
        <FaqSection data-id="element-271" data-mp="l0i8fz5dgvmt" />
        <ClosingSection data-id="element-272" data-mp="l0rr11o380ih" />
      </main>
      <SiteFooter data-id="element-273" data-mp="kzqestvc57z6" />
    </div>;
}